import Token from "./Token.vue";
import { pluginify } from "./../../util";
export default pluginify(Token);
export { Token };
